// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"a35976c0","805":"face6f3f"}[chunkId] + ".chunk.css";
};